import { gql, useQuery } from '@apollo/client';
import useLanguage from 'utils/useLanguage';

import {
  CountriesQuery,
  CountriesQueryVariables,
} from 'client/graphql/types/operations';

const COUNTRIES_QUERY = gql`
  query CountriesQuery($language: Language!) {
    countries {
      name(language: $language)
      alpha3
      alpha2
    }
  }
`;

const useCountriesQuery = () => {
  const language = useLanguage();

  return useQuery<CountriesQuery, CountriesQueryVariables>(COUNTRIES_QUERY, {
    variables: { language },
  });
};

export default useCountriesQuery;
